import { createSlice } from "@reduxjs/toolkit";

const layoutSlice = createSlice({
  name: "layout",
  initialState: { drawerOpen: false },
  reducers: {
    setDrawer: (state, action) => {
      state.drawerOpen = action.payload;
    },
  },
});

export const { setDrawer } = layoutSlice.actions;
export default layoutSlice.reducer;
